export const ENV = 'demo';
export const BASE_URL = 'https://basecamp.demo.ropeup.fr';
export const FRONT_URL = 'https://widget.demo.ropeup.fr/';
export const IMG_BASE_URL = 'https://basecamp.demo.ropeup.fr/';
